import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineControl,
    AiOutlineDollar,
    AiOutlineFile,
    AiOutlineHome,
    AiOutlineLink,
    AiOutlineNumber,
    AiOutlineThunderbolt
} from 'react-icons/ai'

import {TfiRulerAlt} from "react-icons/tfi";
import {MdOutlineBusinessCenter} from "react-icons/md";
import {RatePlanIcon} from "../../../features/rate-plans/images/RatePlanIcon.tsx";
import {rbacActions} from "../../../config/rbac/actions.ts";

const ICON_SIZE = '1.5em';

export const getMenuItems = () => {

    return [
        {
            id: 'dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <AiOutlineHome size={ICON_SIZE}/>,
            rbac: rbacActions.ViewDashboard,
        },
        {
            id: 'pricing',
            link: '/products',
            label: 'Pricing',
            icon: <AiOutlineDollar size={ICON_SIZE}/>,
            rbac: rbacActions.ListProducts,
            defaultOpened: true,
            links: [
                {
                    id: 'products',
                    link: '/products',
                    label: 'Products',
                    icon: <AiOutlineAppstore size={ICON_SIZE}/>,
                    rbac: rbacActions.ListProducts,
                },
                {
                    id: 'product-features',
                    link: '/product-features',
                    label: 'Product Features',
                    icon: <AiOutlineAppstore size={ICON_SIZE}/>,
                    rbac: rbacActions.ListProducts,
                },
                {
                    id: 'rate-plans',
                    link: '/rate-plans',
                    label: 'Rate Plans',
                    icon: <RatePlanIcon size={ICON_SIZE}/>,
                    rbac: rbacActions.ListRatePlans,
                },
            ]
        },
        {
            id: 'billing',
            link: '/customers',
            label: 'Billing',
            icon: <AiOutlineNumber size={ICON_SIZE}/>,
            rbac: rbacActions.ListCustomers,
            defaultOpened: true,
            links: [
                {
                    id: 'customers',
                    link: '/customers',
                    label: 'Customers',
                    icon: <MdOutlineBusinessCenter size={ICON_SIZE}/>,
                    rbac: rbacActions.ListCustomers,
                },
                {
                    id: 'invoices',
                    link: '/invoices',
                    label: 'Invoices',
                    icon: <AiOutlineFile size={ICON_SIZE}/>,
                    rbac: rbacActions.ListInvoices,
                },
                {
                    id: 'billing-providers',
                    link: '/billing-providers',
                    label: 'Billing Providers',
                    icon: <AiOutlineControl size={ICON_SIZE}/>,
                    rbac: rbacActions.ListBillingProviders,
                },
            ]
        },
        {
            id: 'metering',
            link: '/meters',
            label: 'Metering',
            icon: <TfiRulerAlt size={ICON_SIZE}/>,
            rbac: rbacActions.ListMeters,
            defaultOpened: true,
            links: [
                {
                    id: 'meters',
                    link: '/meters',
                    label: 'Meters',
                    icon: <TfiRulerAlt size={ICON_SIZE}/>,
                    rbac: rbacActions.ListMeters,
                },
                {
                    id: 'meter-assignments',
                    link: '/meter-assignments',
                    label: 'Meter Assignments',
                    icon: <AiOutlineLink size={ICON_SIZE}/>,
                    rbac: rbacActions.ListMeterAssignments,
                },
                {
                    id: 'billable-events',
                    link: '/billable-events',
                    label: 'Billable Events',
                    icon: <AiOutlineThunderbolt size={ICON_SIZE}/>,
                    rbac: rbacActions.ListBillableEvents,
                },
                {
                    id: 'activity-logs',
                    link: '/activity-logs',
                    label: 'Usage Records',
                    icon: <AiOutlineFile size={ICON_SIZE}/>,
                    rbac: rbacActions.ListActivityLogs,
                },
            ]
        },
        {
            id: 'reports',
            link: '/reports',
            label: 'Reporting',
            icon: <AiOutlineFile size={ICON_SIZE}/>,
            rbac: rbacActions.ViewDashboard,
        }] as PlatformNavbarMenuItem[];

};

